/**
 * Cookie plugin
 *
 * Copyright (c) 2006 Klaus Hartl (stilbuero.de)
 * Dual licensed under the MIT and GPL licenses:
 * http://www.opensource.org/licenses/mit-license.php
 * http://www.gnu.org/licenses/gpl.html
 *
 */

 jQuery.cookie=function(b,j,m){if(typeof j!="undefined"){m=m||{};if(j===null){j="";m.expires=-1}var e="";if(m.expires&&(typeof m.expires=="number"||m.expires.toUTCString)){var f;if(typeof m.expires=="number"){f=new Date();f.setTime(f.getTime()+(m.expires*24*60*60*1000))}else{f=m.expires}e="; expires="+f.toUTCString()}var l=m.path?"; path="+(m.path):"";var g=m.domain?"; domain="+(m.domain):"";var a=m.secure?"; secure":"";document.cookie=[b,"=",encodeURIComponent(j),e,l,g,a].join("")}else{var d=null;if(document.cookie&&document.cookie!=""){var k=document.cookie.split(";");for(var h=0;h<k.length;h++){var c=jQuery.trim(k[h]);if(c.substring(0,b.length+1)==(b+"=")){d=decodeURIComponent(c.substring(b.length+1));break}}}return d}};

Shopify.Products = (function() {
    var COOKIE_NAME = 'shopify_recently_viewed';
    var COOKIE_CONFIG = { expires: 90, path: '/', domain: window.location.hostname };
    var MAX_IN_MEMORY = 10;

    function readCookie() {
        var val = jQuery.cookie(COOKIE_NAME);
        return (val !== null && val !== '' && val !== undefined) ? val.split(' ') : [];
    }

    function writeCookie(handles) {
        jQuery.cookie(COOKIE_NAME, handles.join(' '), COOKIE_CONFIG);
    }

    return {
        showRecentlyViewed: function(params) {
            params = params || {};
            var handles = readCookie();
            if (!handles.length) return;

            var limit = Math.min(handles.length, params.howManyToShow || 4);
            var wrapperId = params.wrapperId || 'recently-viewed-products';
            var wrapperEl = jQuery('#' + wrapperId);
            if (!wrapperEl.length) return;

            var onComplete = params.onComplete || null;
            var swipe = params.swipe || false;
            var templateId = params.templateId || '';

            // Popup path: fetch each product individually
            if (templateId === 'recently-viewed-product-popup') {
                var queue = handles.slice(0, limit);
                var shown = 0;

                (function next() {
                    if (!queue.length || shown >= limit) {
                        wrapperEl.show();
                        if (onComplete) { try { onComplete(); } catch(e) {} }
                        return;
                    }
                    var handle = queue.shift();
                    jQuery.get(window.routes.root + '/products/' + handle + '?view=ajax_recently_viewed')
                        .done(function(html) { wrapperEl.append(html); shown++; })
                        .fail(function() {})
                        .always(function() { next(); });
                })();
                return;
            }

            // Section path: fetch each product individually using the product card template
            var toFetch = handles.slice(0, limit);
            var results = new Array(toFetch.length);
            var done = 0;

            toFetch.forEach(function(handle, i) {
                jQuery.get(window.routes.root + '/products/' + handle + '?view=ajax_recently_viewed_card')
                    .done(function(html) { results[i] = html; })
                    .fail(function() { results[i] = null; })
                    .always(function() {
                        done++;
                        if (done === toFetch.length) {
                            wrapperEl.empty();
                            for (var j = 0; j < results.length; j++) {
                                if (results[j]) {
                                    wrapperEl.append(results[j]);
                                }
                            }
                            wrapperEl.addClass('recently-viewed-loaded');
                            if (onComplete) { try { onComplete(); } catch(e) {} }
                        }
                    });
            });
        },

        clearList: function() {
            jQuery.cookie(COOKIE_NAME, null, COOKIE_CONFIG);
        },

        recordRecentlyViewed: function() {
            if (window.location.pathname.indexOf('/products/') === -1) return;

            var match = window.location.pathname.match(/\/products\/([a-z0-9\-]+)/);
            var productHandle = match ? match[1] : decodeURIComponent(window.location.pathname.split('/products/')[1]);

            var list = readCookie();
            var pos = jQuery.inArray(productHandle, list);
            if (pos !== -1) list.splice(pos, 1);
            list.unshift(productHandle);
            list = list.slice(0, MAX_IN_MEMORY);
            writeCookie(list);
        }
    };
})();
